const maxWidth = 1000;

export default payload => {
  return new Promise((resolve, reject) => {
    const { src, threshold } = payload;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.src = src;

    img.onload = function() {
      const preWidth = img.width;
      const preHeight = img.height;

      if (preWidth > preHeight) {
        if (preWidth > maxWidth) {
          img.setAttribute('width', maxWidth);
          img.setAttribute('height', (maxWidth / preWidth) * preHeight);
        }
      } else {
        if (preHeight > maxWidth) {
          img.setAttribute('height', maxWidth);
          img.setAttribute('width', (maxWidth / preHeight) * preWidth);
        }
      }

      // Set canvas dimensions to match the image
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw the image onto the canvas
      ctx.drawImage(this, 0, 0, this.width, this.height);

      // Get image data
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // Loop through each pixel and apply black and white
      for (let i = 0; i < data.length; i += 4) {
        // Get the RGB values
        let r = data[i];
        let g = data[i + 1];
        let b = data[i + 2];

        // Calculate grayscale value for black and white
        let gray = 0.3 * r + 0.59 * g + 0.11 * b;

        // Map the threshold value (-100 to 100) to a 0-255 range
        const mappedThreshold = (threshold + 100) * (255 / 200);
        // Apply threshold
        gray = gray >= mappedThreshold ? 255 : 0;

        // Set the RGB values to the grayscale value
        data[i] = data[i + 1] = data[i + 2] = gray;
      }

      // Put the processed data back onto the canvas
      ctx.putImageData(imageData, 0, 0);

      resolve(canvas.toDataURL());
    };
  });
};
